import { css } from "styled-components";
import { Icon } from "../../../Icon";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${chroma.typography.body3};
  display: flex;
  flex-direction: column;

  .copy-to-clipboard_description,
  .copy-to-clipboard_success {
    font-weight: 700;
    ${textUppercaseMixin};
  }

  .copy-to-clipboard_description {
    padding: 8px 0;
  }

  .copy-to-clipboard_item {
    color: ${chroma.input.foreground};
    background-color: #fcfcfc;
    display: flex;
    align-items: center;
    width: fit-content;
    height: fit-content;
    max-width: fill-available;
    padding: 16px;
    word-break: break-all;
    cursor: pointer;

    & > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 8px;
    }
  }

  .copy-to-clipboard_success {
    ${chroma.typography.label}
    color: ${paletteTokens.bladetext1};
    display: flex;
    padding-top: 9.5px;
    align-items: center;
    transition: opacity 0.1s;

    span {
      padding-left: 4px;
    }
  }

  ${Icon} {
    background-color: ${paletteTokens.accents1};
    flex-shrink: 0;
  }
`;
//# sourceMappingURL=index.js.map